export default {"src":"/app/membership/_next/static/media/testimonial-carousel-dog.e489e08a.svg","height":236,"width":292,"blurWidth":0,"blurHeight":0};